<template>
  <div id="about" class="d-flex justify-content-center">
    <div class="padding">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <img class="img-fluid" src="../assets/about.jpg" alt />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <div class="row">
            <div class="col-12">
              <h2 style="color: #ba2428;">About</h2>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <p>
                TribeID is the implementation of a protocol
                for strengthening the export-readiness of
                African SMEs (small and medium enterprises)
                according to AfCFTA principles.
              </p>
              <p>
                Developed at
                <a href="https://sankoree.com/">the Sankoree Institute</a>, an ideas incubator and observatory for
                AfCFTA acceleration, TribeID has three main
                pillars:
              </p>
              <ul>
                <li>Universal Track Record Visibility</li>
                <li>
                  A lightweight continental
                  reputation-based guarantee mechanism &
                </li>
                <li>
                  A Pan-African e-Commerce
                  Inter-operability framework
                </li>
              </ul>
              <p>
                These three dimensions interlock to create
                powerful rails on which other more elaborate
                continental initiatives for SME can smoothly
                transit.
              </p>
              <p>
                TribeID borrows from Credmap’s
                reputation-scoring model and Fiscoins
                token-logic in certain essential aspects.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.about ul {
	list-style-type: circle red;
}
</style>